var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "currentColor",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 3.834H3.833a1.914 1.914 0 0 0-1.907 1.917l-.01 11.5c0 1.054.863 1.916 1.917 1.916h15.334a1.922 1.922 0 0 0 1.916-1.916V5.75a1.922 1.922 0 0 0-1.916-1.917Zm-.959 13.417H4.792a.961.961 0 0 1-.959-.959V7.667l6.651 4.16a1.898 1.898 0 0 0 2.032 0l6.65-4.16v8.625a.961.961 0 0 1-.958.959ZM11.5 10.542 3.833 5.751h15.334L11.5 10.542Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail24);
export default __webpack_public_path__ + "static/media/mail_24.ea2204d46ac781a77ac14ca282423888.svg";
export { ForwardRef as ReactComponent };